import { styled } from '@mui/material';

export const RootStyled = styled('div')(({ theme }) => ({
  padding: theme.spacing(7),
  fontFamily: 'montserrat',
  marginTop: -60,
}));

export const BoxConfigStyled = styled('div')({
  marginTop: 45,
});
